/**
 * Transform the Kraken raw format of off-peak hours string into a more readable format
 * (e.g. "HC (2H30-8H30,14H30-16H30)" => "2h30-8h30,14h30-16h30")
 */
export function formatOffPeakHours(offPeakHours: string) {
    return offPeakHours
        .replace(/^HC \((.*)\)$/, "$1")
        .replace(/H/g, "h")
        .replace(/[,;]/g, " et ")
}
